// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-badge-text {\n  color: #eee;\n  padding: 2px;\n  border-radius: 12px;\n  margin: 0 16px;\n  font-size: 16px;\n  padding: 4px 12px;\n}\n.info-badge-text.blue {\n  background-color: #3ba0b1;\n}\n.info-badge-text.green {\n  background-color: #65bb65;\n}\n.info-badge-text.red {\n  background-color: #f30000;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
